module.exports = __webpack_public_path__ + "2fac67ecfe0cfcf485cd549f8731bc14.svg";